import {
  FinancialAdvisor,
  ProductMacroCategoryType,
} from '../../model';
import { MacroCategorie, Portafoglio } from '../generated';
import { DatiAgente } from '../generated/anagrafica';
import { PersonalDataResponse } from '../generated/objectway-zenith';
import { parseServerAmount } from './commons-api-parsers';

const mapMacroCategorieTypeToProductMacroCategoryType: {
  [key in keyof MacroCategorie]: ProductMacroCategoryType;
} = {
  gestito: 'Managed',
  assicurativoFinanziario: 'FinancialInsurance',
  previdenza: 'Welfare',
  amministrativo: 'Administered',
  liquidita: 'Liquidity',
  assicurativoTradizionale: 'TraditionalInsurance',
  economiaReale: 'RealEconomy',
  totalFia:'TotalFia',
  totalePortafoglio:"TotalPortfolio"
};

const keys: (keyof MacroCategorie)[] = [
  'gestito',
  'assicurativoFinanziario',
  'previdenza',
  'amministrativo',
  'liquidita',
  'assicurativoTradizionale',
  'economiaReale',
  "totalFia",
  "totalePortafoglio"
];

export const parsePortafoglioToDashboardWalletSummary = (
  portafoglio: Portafoglio
): any => {
const totalAmount = parseServerAmount(
  portafoglio.elencoPosizioni?.totalePortafoglio?.totale ?? { valore: 0, divisa: '€' }
);
const summaryLiquidity = portafoglio.summary?.liquidita;

  return {
    richiamiInAttesa: parseServerAmount(
      portafoglio.summary?.totaleRichiamiInAttesa ?? { valore: 0, divisa: '€' }
    ),
    totalAmount: {
      value: totalAmount.value || 0,
      currency: totalAmount.currency || 'EUR',
    },
    macroCategories: keys.flatMap((key) => {
      const position = portafoglio.elencoPosizioni?.[key];
      // Includiamo sempre FIA e Totale Portafoglio per gestire i casi con valore 0
      if (key === 'totalFia' || key === 'totalePortafoglio' || position) {
        return [
          {
            type: mapMacroCategorieTypeToProductMacroCategoryType[key],
            amount:
              key === 'totalePortafoglio'
                ? parseServerAmount(
                    (position as any)?.totaleComplessivo ?? {
                      valore: 0,
                      divisa: '€',
                    }
                  )
                : key === 'liquidita' && typeof summaryLiquidity === 'number'
                  ? parseServerAmount({
                      valore: summaryLiquidity,
                      divisa: 'EUR',
                    })
                  : key !== 'assicurativoTradizionale'
                    ? parseServerAmount(
                        (position as any)?.totale ?? {
                          valore: 0,
                          divisa: '€',
                        }
                      )
                    : { value: 0, currency: 'EUR' },
          },
        ];
      }
      return [];
    }),
  };
};



export const parseDatiAgenteToFinancialAdvisor = (
  agente: DatiAgente
): FinancialAdvisor => {
  return {
    name: agente?.nome,
    surname: agente?.cognome,
    phone: agente?.cellulare,
    email: agente?.email,
    address: {
      address: agente?.indirizzoUfficio?.indirizzo,
      zipCode: agente?.indirizzoUfficio?.cap,
      city: agente?.indirizzoUfficio?.desLocalita,
      country: agente?.indirizzoUfficio?.codNazione,
      cityCode: agente?.indirizzoUfficio?.codProvincia,
    },
    avatar: '', // TODO: capire da dove recuperare questa info
  };
};
const getContact = (agente: any, type: string) =>
  agente?.contacts?.find(
    (c: any) => c?.contactType === type
  )?.contact ?? '';

export const parsePersonalDataResponseToFinancialAdvisor = (
  agente: PersonalDataResponse
): FinancialAdvisor => {
  return {
    name: agente?.generalInfo?.firstName ?? '',
    surname: agente?.generalInfo?.lastName ?? '',
    phone: getContact(agente,'2'),
    email: getContact(agente,'3'),
    address: {
      address: agente?.addresses?.[0]?.address ?? '',
      zipCode: agente?.addresses?.[0]?.zipCode ?? '',
      city: agente?.addresses?.[0]?.city ?? '',
      country: agente?.addresses?.[0]?.country ?? '',
      cityCode: agente?.addresses?.[0]?.province ?? '',
    },
    avatar: '', // TODO: capire da dove recuperare questa info
  };
};
